import React from 'react';

import {PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {CustomComponentEditorProps} from 'pipelines/generalized-step-config-editor/StepConfigEditorTypes';
import {PipelineStepConfig} from 'pipelines/PipelineTypes';
import {ButtonSize} from 'ui-library/buttons/Button';
import ToggleGroup from 'ui-library/ToggleGroup';
import {JSONValue} from 'util/Types';

type IsInputX = PipelineStepConfig<PipelineStepType.REGRESSION_INTERPOLATION, 0, 'draft'>['isInputX'];

/** @package */
export enum IsInputXOption {
  X = 'x',
  Y = 'y',
}

export default function IsInputXToggleGroup({
  config: fullConfig,
  onChangeConfig,
}: CustomComponentEditorProps): JSX.Element {
  const isInputX = fullConfig.isInputX as IsInputX;
  const selection = isInputX === false ? IsInputXOption.Y : IsInputXOption.X;
  function onChangeSelection(newSelection: IsInputXOption): void {
    const newValue: IsInputX = newSelection === IsInputXOption.X;
    onChangeConfig(fullConfig, ['isInputX'], newValue as unknown as JSONValue);
  }

  return (
    <ToggleGroup<IsInputXOption>
      options={[
        {id: IsInputXOption.X, buttonProps: {text: 'Use inputs as X to predict Y'}},
        {id: IsInputXOption.Y, buttonProps: {text: 'Use inputs as Y to predict X'}},
      ]}
      selection={selection}
      onChangeSelection={onChangeSelection}
      size={ButtonSize.MEDIUM}
    />
  );
}
